import React, { Component } from "react";
import AlertContainer from 'react-alert'
import { connect } from "react-redux";

import NavigationBar from "../../components/NavigationBar";
import FixedFooter from "../../components/FixedFooter";
import FbWrapper from '../../lib/FirebaseWrapper';

const styles = {
  body: {
    display: "grid",
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "50px"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 60,
    paddingRight: 60,
    backgroundColor: "#4990E2",
    borderRadius: 5,
    boxShadow: `10px 30px 70px #9E9E9E`,
    justifyContent: "center",
    alignItems: "center"
  },
  tokenTitle: {
    marginBottom: 12,
    fontSize: 18,
    color: 'white'
  },
  tokenInput: {
    fontSize: 14,
    lineHeight: '24px',
    marginTop: 4,
    marginBottom: 4,
    padding: 2,
    borderColor: 'rgba(0,0,0,0.3)',
    borderRadius: 8,
    backgroundColor: 'white',
    width: 220,
    textAlign: 'center'
  },
  submitButton: {
    marginTop: 16
  }
};

const alertOptions = {
  offset: 14,
  position: 'bottom left',
  theme: 'light',
  time: 5000,
  transition: 'scale'
}

class SubmitTokenView extends Component {
  constructor() {
    super();
    this.state = {
      token: undefined
    };
  }

  _onSubmit() {
    const token = this.state.token;
    if (token===undefined || token.length<10) {
      this.setState({token: undefined});
      this._renderFailureMessage("Invalid token from Robinhood!");
    } else {
      const uid = this.props.authUser.uid;
      if (!uid) {
        this._renderFailureMessage("Unknown Account ID!");
        return;
      }

      FbWrapper.submitRobinhoodToken(uid, this.state.token)
        .then(() => {
          this._renderSuccessMessage("Token saved!");
          this.props.history.push("/livetrading");
        });
    }
  }

  _renderSuccessMessage(message) {
    this.msg.show(message, {
      time: 2000,
      type: 'success'
    });
  }

  _renderFailureMessage(message) {
    this.msg.show(message, {
      time: 2000,
      type: 'error',
      icon: <img src="http://i.imgur.com/C7RBc0g.png" alt="error" style={{width:32, height:32}} />
    });
  }

  render() {
    return (
      <div>
        <NavigationBar history={this.props.history} />
        <AlertContainer ref={a => this.msg = a} {...alertOptions} />

        <div style={styles.body}>
          <div style={styles.container}>
            <a style={styles.tokenTitle}>Submit Robinhood Token</a>
            <input
              type="text"
              style={styles.tokenInput}
              placeholder="token"
              onChange={e => this.setState({ token: e.target.value })}
              onKeyPress={event => {
                if (event.key === "Enter") { this._onSubmit(); }
              }}
              autoFocus={true}
            />
          <button
            style={styles.submitButton}
            onClick={() => this._onSubmit()}
          >SAVE</button>
          </div>
        </div>
        <FixedFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser
})

export default connect(mapStateToProps)(SubmitTokenView)



// WEBPACK FOOTER //
// ./src/views/LiveTradingView/SubmitTokenView.js